import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import api from '../services/api'

export default function CartaoProtocolo() {
  const { id } = useParams()
  const [processo, setProcesso] = useState(null)
  const urlConsulta = `${window.location.origin}/consulta`

  useEffect(() => {
    api.get(`/processos/${id}`).then(r => {
      setProcesso(r.data)
      setTimeout(() => window.print(), 1000)
    }).catch(() => {})
  }, [id])

  if (!processo) return <div style={{ padding:40, textAlign:'center', fontFamily:'system-ui' }}>Carregando...</div>

  // QR Code usando API sem CORS
  const urlParaQR = `${urlConsulta}?n=${encodeURIComponent(processo.numero)}`
  const qrSrc = `https://quickchart.io/qr?text=${encodeURIComponent(urlParaQR)}&size=120&margin=1`

  return (
    <div style={{ fontFamily:'system-ui,sans-serif', padding:40, maxWidth:520, margin:'0 auto' }}>
      <style>{`@media print { .no-print { display:none!important; } @page { margin: 15mm; } }`}</style>

      <div className="no-print" style={{ marginBottom:20, display:'flex', gap:10 }}>
        <button onClick={() => window.print()} style={{ padding:'8px 16px', background:'#185FA5', color:'white', border:'none', borderRadius:8, cursor:'pointer', fontSize:13 }}>🖨 Imprimir</button>
        <button onClick={() => window.close()} style={{ padding:'8px 16px', border:'1px solid #d1d5db', borderRadius:8, cursor:'pointer', fontSize:13, background:'white' }}>Fechar</button>
      </div>

      <div style={{ border:'2px solid #185FA5', borderRadius:12, overflow:'hidden' }}>
        <div style={{ background:'#185FA5', padding:'14px 20px', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <div>
            <div style={{ color:'white', fontSize:18, fontWeight:700 }}>ProtoGov</div>
            <div style={{ color:'#B5D4F4', fontSize:12, marginTop:2 }}>Comprovante de Protocolo</div>
          </div>
        </div>

        <div style={{ padding:20 }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', gap:16, marginBottom:20 }}>
            <div style={{ flex:1 }}>
              <div style={{ fontSize:11, color:'#9ca3af', textTransform:'uppercase', letterSpacing:'0.5px' }}>Número do protocolo</div>
              <div style={{ fontSize:22, fontWeight:700, color:'#185FA5', fontFamily:'monospace', marginTop:4 }}>{processo.numero}</div>

              <div style={{ marginTop:14, display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
                {[
                  ['Requerente', processo.req_nome],
                  ['CPF/CNPJ', processo.req_cpf_cnpj||'—'],
                  ['Tipo', processo.tipo_nome||'—'],
                  ['Data de abertura', new Date(processo.aberto_em).toLocaleDateString('pt-BR')],
                  ['Prazo', processo.prazo_em?new Date(processo.prazo_em).toLocaleDateString('pt-BR'):'—'],
                  ['Status', processo.status],
                ].map(([l,v]) => (
                  <div key={l}>
                    <div style={{ fontSize:10, color:'#9ca3af', textTransform:'uppercase', letterSpacing:'0.4px' }}>{l}</div>
                    <div style={{ fontSize:12, color:'#111', marginTop:1, fontWeight:500 }}>{v}</div>
                  </div>
                ))}
              </div>

              <div style={{ marginTop:12 }}>
                <div style={{ fontSize:10, color:'#9ca3af', textTransform:'uppercase', letterSpacing:'0.4px' }}>Assunto</div>
                <div style={{ fontSize:12, color:'#111', marginTop:1 }}>{processo.assunto}</div>
              </div>
            </div>

            <div style={{ textAlign:'center', flexShrink:0 }}>
              <img src={qrSrc} alt="QR Code" width={110} height={110}
                style={{ display:'block', border:'1px solid #e5e7eb', borderRadius:4 }}
                onError={e => { e.target.style.display='none' }} />
              <div style={{ fontSize:10, color:'#9ca3af', marginTop:4, maxWidth:110, lineHeight:1.3 }}>Escaneie para consultar</div>
            </div>
          </div>

          <div style={{ borderTop:'1px solid #e5e7eb', paddingTop:14 }}>
            <div style={{ fontSize:11, color:'#6b7280', marginBottom:4 }}>Acompanhe seu processo online:</div>
            <div style={{ fontFamily:'monospace', fontSize:12, color:'#185FA5', background:'#E6F1FB', padding:'6px 10px', borderRadius:6, display:'inline-block' }}>
              {urlConsulta}
            </div>
            <div style={{ fontSize:10, color:'#9ca3af', marginTop:8 }}>
              Guarde este comprovante. O número de protocolo é necessário para consultar o andamento.
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
